import z from "zod";
import { teamCapabilities } from "../../../organizations";

export const getTeamParamsSchema = z.object({
	teamId: z.uuid(),
});

export const getTeamsQuerySchema = z.object({
	membership: z.enum(["leader", "member"]).optional(),
});

export const teamMemberListItemSchema = z.object({
	id: z.string(),
	teamId: z.uuid(),
	name: z.string(),
	firstName: z.string(),
	lastName: z.string(),
	capabilities: z.preprocess(
		(val) => {
			if (!Array.isArray(val)) return [];
			if (Array.isArray(val) && typeof val.at(0) === "string") return val;
			return [];
		},
		z.array(z.enum(teamCapabilities)).min(0),
	),
});

export const teamMemberListSchema = z.array(teamMemberListItemSchema);

export type TeamMemberListItemSchema = z.infer<typeof teamMemberListItemSchema>;
export type TeamMemberListSchema = z.infer<typeof teamMemberListSchema>;
export type GetTeamParamsSchema = z.infer<typeof getTeamParamsSchema>;
export type GetTeamsQuerySchema = z.infer<typeof getTeamsQuerySchema>;
